import ColourPalette from '@/support/ColourPalette'

export default class OvertimeColour extends ColourPalette {}
